/**
 * Accordion
 * ======================================
 * - slideup slidedown animation via css height transition
 */

const ELEMENTS = ".js-Accordion .js-Accordion-header";
const TOGGLE_CLASS = "is-open";

class Accordion {
  constructor() {
    this.elements = document.querySelectorAll(ELEMENTS);

    if (!this.elements) {
      return false;
    }

    this.elements.forEach((el) => {
      el.addEventListener("click", this.toggle);
    });

    window.addEventListener('resize', this.recalculate);
  }

  recalculate = () => {
   const open = document.querySelectorAll('.js-Accordion .is-open');

   open.forEach((el) => {
     el.classList.remove(TOGGLE_CLASS)
     el.querySelector('.faq__item-text').remove(TOGGLE_CLASS)
   })
  }

  toggle = (e) => {
    const el = e.currentTarget;
    const target = el.parentNode;
    const classes = target.classList

    if(classes.contains(TOGGLE_CLASS)){
     classes.remove(TOGGLE_CLASS);
    } else {
     classes.add(TOGGLE_CLASS);
    }

    e.preventDefault();
  };
}

document.addEventListener("DOMContentLoaded", () => {
  new Accordion();
})
